module.exports = __webpack_public_path__ + "img/1707036477447-asuwibu.jpg.dd0b72b9.webp";